import React from "react";

const Special = () => {
  return (
    <section id="special">
      <div className="endpoint">Special Dynamic Routes</div>
      In search of pick-up lines tailored to your specific preferences? Look no
      further. We offer an array of categories to choose from, including
      "romantic," "funny," "cheesy," "flirty," "clever," and "sweet." Select
      your preferred category, and we shall present you with charming pick-up
      lines that align with your mood and style.
      <div className="dbline"></div>
      <div className="subheading">How to Use:</div>
      Get Pick-Up Lines by Category and Language.
      <div className="dbline"></div>
      <div className="line"></div>
    </section>
  );
};

export default Special;
